import { APP_INITIALIZER, ErrorHandler } from '@angular/core';
import { Router } from '@angular/router';

import { provideStoreDevtools } from '@ngrx/store-devtools';
import * as Sentry from '@sentry/angular';

import { environment } from '@env/environment';

import { REQUEST, requestFactory } from '@personal-area/common';

import { appProviders } from './app.module';
import { initSentry } from './core/utility/sentry';

export const appBrowserProviders = [
  ...appProviders,
  {
    // The server provides these in main.server
    provide: REQUEST,
    useFactory: requestFactory,
  },
  environment.isStage || !environment.production
    ? provideStoreDevtools({ connectInZone: true, trace: true })
    : [],
  !environment.isStage && environment.production
    ? [
        {
          provide: ErrorHandler,
          useValue: Sentry.createErrorHandler(),
        },
        {
          provide: Sentry.TraceService,
          deps: [Router],
        },
        {
          provide: APP_INITIALIZER,
          useFactory: () => () => initSentry(),
          deps: [Sentry.TraceService],
          multi: true,
        },
      ]
    : [],
];
